import { addBusinessDays, parseISO } from "date-fns";

export const getDayFromToday: (daysFromToday: number) => Date = (
  daysFromToday
) => {
  return addBusinessDays(new Date(), daysFromToday);
};

/**
 *
 * @param iso8601String ex: 2024-03-01
 * @returns Wed Mar 01 2024 00:00:00 GMT-0700 (Pacific Daylight Time)
 */
export const convertISO8601ToBrowserDate = (iso8601String: string) => {
  return parseISO(iso8601String);
};
